export default __webpack_public_path__ + "static/media/codrops.86d8a938.png";